import { PrimaryNavigationItemProps } from '@manychat/manyui/src/components/Navigation/NavigationItem/interfaces'

import { useAppSelector } from 'reduxTyped'
import { getThreadsCounterForTab } from 'apps/chat/selectors/countersSelectors'
import { MIN_SUBSCRIBERS_FOR_BROADCAST_PROMOTION } from 'apps/dashboard/components/HomeTab/HomeTabBlockBanners/constants'
import { ChannelType } from 'common/core/constants/ChannelType'
import { getHasAnyBroadcasts } from 'common/core/selectors/appSelectors'
import {
  hasConnectedInstagramChannel,
  isFBChannelConnected,
} from 'common/core/selectors/channelSelectors'
import { getReasonWithMoreSubscribers } from 'common/oneTimeNotify/selectors/notifyReasonSelectors'
import { useSettingsTabWithNotification } from 'common/settings/hooks/useSettingsTabWithNotification'
import { AccountFlag } from 'utils/services/featureFlagsService/constants'
import { useAccountReleaseToggle } from 'utils/services/featureFlagsService/releaseTogglesHooks'

import { NavigationRouteIds } from '../navigationRoutes'

interface RouteNotifications {
  hasNotification?: PrimaryNavigationItemProps['hasNotification']
  notificationCount?: PrimaryNavigationItemProps['notificationCount']
  notificationColor?: PrimaryNavigationItemProps['notificationColor']
}

type AllRouteNotifications = Partial<Record<NavigationRouteIds, RouteNotifications>>

const emptyObj: RouteNotifications = {}

export const useRouteNotifications = (id: NavigationRouteIds): RouteNotifications => {
  const hasConnectedFBChannel = useAppSelector(isFBChannelConnected)
  const hasConnectedIGChannel = useAppSelector(hasConnectedInstagramChannel)
  const enableIGRecurringNotification = useAccountReleaseToggle(
    AccountFlag.ENABLE_IG_RECURRING_NOTIFICATION,
  )
  const hasIGRn = enableIGRecurringNotification && hasConnectedIGChannel
  const hasNoBroadcasts = !useAppSelector(getHasAnyBroadcasts)
  const channelForCalculation = hasIGRn ? ChannelType.INSTAGRAM : ChannelType.FB
  const topicWithMoreSubscribers = useAppSelector((state) =>
    getReasonWithMoreSubscribers(state, channelForCalculation),
  )
  const maxTopicSubscribersCount = topicWithMoreSubscribers?.value ?? 0
  const hasEnoughOptIns = maxTopicSubscribersCount > MIN_SUBSCRIBERS_FOR_BROADCAST_PROMOTION
  const hasCompletedRNOnBoarding =
    (hasConnectedFBChannel || hasIGRn) && hasNoBroadcasts && hasEnoughOptIns

  const settingsTabNotification = useSettingsTabWithNotification()
  const openedThreads = useAppSelector(getThreadsCounterForTab)

  const allRouteNotifications: AllRouteNotifications = {
    [NavigationRouteIds.CHAT]: {
      notificationCount: openedThreads ? String(openedThreads) : '',
    },
    [NavigationRouteIds.BROADCASTS]: {
      hasNotification: hasCompletedRNOnBoarding,
      notificationColor: 'var(--color-icon-brand-secondary)',
    },
    [NavigationRouteIds.SETTINGS]: {
      hasNotification: Boolean(settingsTabNotification),
      notificationColor: 'var(--color-icon-danger)',
    },
  }

  return allRouteNotifications[id] || emptyObj
}
